import {
  InputElementUnion,
  ITextInputElement,
  isTextInputElement,
  isInputElement,
  MaxLengthValidationSchema,
  MinLengthValidationSchema,
  AllowedCharactersSchema,
  RegExpValidationSchema,
  CharTypesMatcherState,
} from "@graffer-inc/form-schema";
import { CommonPropertiesEditor } from "../common-properties-editor";

type TextInputEditorProps = {
  element: ITextInputElement;
  onElementUpdate: (element: InputElementUnion) => void;
};

// form-builder の TextInputEditor
// see: https://github.com/graffer-inc/graffer-schemas/blob/70784b3c071948bd221f8268b58112603a8d87fd/libs/packages/form-builder/lib/elements/editor-pane/element-editor/editors/text-input-editor/text-input-editor.tsx
export const TextInputEditor: React.FC<TextInputEditorProps> = ({
  element,
  onElementUpdate,
}) => {
  if (!isInputElement(element) || !isTextInputElement(element)) {
    return null;
  }

  const maxLengthSchema = element.validations.find(
    (elem) => elem.keyword === "maxLength",
  ) as MaxLengthValidationSchema | undefined;
  const minLengthSchema = element.validations.find(
    (elem) => elem.keyword === "minLength",
  ) as MinLengthValidationSchema | undefined;
  const allowedCharsSchema = element.validations.find(
    (elem) => elem.keyword === "allowedCharacters",
  ) as AllowedCharactersSchema | undefined;
  const regExpSchema = element.validations.find(
    (elem) => elem.keyword === "regexp",
  ) as RegExpValidationSchema | undefined;

  // see: https://github.com/graffer-inc/graffer-schemas/blob/70784b3c071948bd221f8268b58112603a8d87fd/libs/packages/form-builder/lib/elements/editor-pane/element-editor/editors/validation/allowed-characters.tsx#L68-L75
  const allowedChars = allowedCharsSchema
    ? allowedCharsSchema.value
        .map((k) =>
          new CharTypesMatcherState(k).matchType({
            alphabet: "英字",
            hiragana: "ひらがな",
            katakana: "カタカナ",
            numeric: "数字",
            full_width_space: "全角スペース",
            half_width_space: "半角スペース",
          }),
        )
        .join(", ")
    : "設定なし";

  return (
    <>
      <CommonPropertiesEditor
        element={element}
        onElementUpdate={onElementUpdate}
      />
      {/** プレースホルダー */}
      <div className="field">
        <label className="label">プレースホルダー</label>
        <div className="control">
          <input
            className="input"
            placeholder={element.placeholder}
            value={element.placeholder}
            onChange={(e) => {
              onElementUpdate({ ...element, placeholder: e.target.value });
            }}
          />
        </div>
      </div>
      {/** InitialValueComponent */}
      <div className="field">
        <label className="label">初期値設定</label>
        {!element.initialValue && (
          <div className="control">
            <p>設定なし</p>
          </div>
        )}
        {element.initialValue && (
          <div className="control">
            <p>{element.initialValue.value.toString()}</p>
          </div>
        )}
      </div>
      {/** TextInputValidationEditor */}
      <hr />
      <div className="field">
        <label className="label">入力規則設定</label>
        <div className="field">
          <label className="label">最大文字数</label>
          <div className="control">
            <p>{maxLengthSchema ? maxLengthSchema.value : "設定なし"}</p>
          </div>
        </div>
        <div className="field">
          <label className="label">最小文字数</label>
          <div className="control">
            <p>{minLengthSchema ? minLengthSchema.value : "設定なし"}</p>
          </div>
        </div>
        <div className="field">
          <label className="label">許容文字種</label>
          <div className="control">
            <p>{allowedChars}</p>
          </div>
        </div>
        <div className="field">
          <label className="label">正規表現</label>
          <div className="control">
            <p>{regExpSchema ? regExpSchema.value : "設定なし"}</p>
          </div>
        </div>
      </div>
    </>
  );
};
